import React from 'react';
import PropTypes from 'prop-types';
import MediaPlaceholder from 'src/js/modules/common/components/media-placeholder';
import BackgroundBox from 'src/js/modules/common/components/background-box';

function GalleryImagePreview({ url = '', placeholderType = null, isPlaceholder = false }) {
  return (
    <div className="ws-gallery-image-preview">
      <div className="ws-gallery-image-preview__background-box">
        {isPlaceholder ? <MediaPlaceholder type={placeholderType} /> : <BackgroundBox url={url} />}
      </div>
    </div>
  );
}

GalleryImagePreview.propTypes = {
  url: PropTypes.string,
  placeholderType: PropTypes.string,
  isPlaceholder: PropTypes.bool,
};

export default GalleryImagePreview;
